import { useState, useRef, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfter = ({ before, after, beforeLabel = "Before", afterLabel = "After" }) => {
  const [pos, setPos] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const setFromClientX = useCallback((clientX) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, pct)));
  }, []);

  const onPointerDown = (e) => {
    dragging.current = true;
    e.currentTarget.setPointerCapture?.(e.pointerId);
    setFromClientX(e.clientX);
  };
  const onPointerMove = (e) => {
    if (!dragging.current) return;
    setFromClientX(e.clientX);
  };
  const stop = () => (dragging.current = false);

  return (
    <div
      ref={containerRef}
      data-testid="before-after-slider"
      className="relative w-full h-[360px] md:h-[560px] overflow-hidden select-none cursor-ew-resize bg-[#1A1A1A]"
      style={{ touchAction: "none" }}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stop}
      onPointerCancel={stop}
      onPointerLeave={stop}
    >
      <img src={after} alt={afterLabel} className="absolute inset-0 w-full h-full object-cover pointer-events-none" draggable={false} />
      <span className="absolute top-5 right-5 overline text-[#FAF9F6] bg-[#1A1A1A]/50 px-3 py-1.5 backdrop-blur-sm">{afterLabel}</span>

      <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt={beforeLabel}
          className="absolute inset-0 h-full object-cover max-w-none"
          style={{ width: containerRef.current ? containerRef.current.offsetWidth : "100%" }}
          draggable={false}
        />
        <span className="absolute top-5 left-5 overline text-[#1A1A1A] bg-[#FAF9F6]/80 px-3 py-1.5 backdrop-blur-sm">{beforeLabel}</span>
      </div>

      <div className="absolute top-0 bottom-0 pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute top-0 bottom-0 -translate-x-1/2 w-px bg-[#FAF9F6]" />
        <div className="absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-[#FAF9F6] flex items-center justify-center shadow-lg">
          <MoveHorizontal size={18} className="text-[#1A1A1A]" />
        </div>
      </div>
    </div>
  );
};
